import * as Headless from '@headlessui/react'
import { clsx } from 'clsx'
// import { Link } from './link'
import { Link } from "react-router-dom"


const variants = {
  primary: clsx(
    'inline-flex items-center justify-center px-6 py-[calc(theme(spacing.2))]',
    'rounded-full bg-black text-white font-medium shadow-md',
    'whitespace-nowrap',
    'hover:bg-black transition',
    'disabled:opacity-40'
  ),
  secondary: clsx(
    'inline-flex items-center justify-center px-6 py-[calc(theme(spacing.2))]',
    'rounded-full bg-white text-black font-medium shadow-md border border-transparent',
    'whitespace-nowrap',
    'hover:bg-gray-100 transition',
    'disabled:opacity-40'
  ),
  outline: clsx(
    'inline-flex items-center justify-center px-2 py-[calc(theme(spacing.[1.5])-1px)]',
    'rounded-full bg-transparent text-black font-medium border border-black',
    'whitespace-nowrap',
    'hover:bg-gray-100 transition',
    'disabled:opacity-40'
  ),
}


type ButtonProps = {
  variant?: keyof typeof variants
  className?: string
} & (
  | React.ComponentPropsWithoutRef<typeof Link> // Props for Link
  | React.ComponentPropsWithoutRef<'button'>    // Props for Headless.Button
)

const Button = ({
  variant = 'primary',
  className,
  ...props
}: ButtonProps) => {
  const combinedClassName = clsx(className, variants[variant])

  if ('to' in props) {
    // Renders Link if `to` prop is defined
    return <Link {...props} className={combinedClassName} />
  }

  // Renders Headless.Button otherwise
  return <Headless.Button {...props} className={combinedClassName} />
}



export default Button;



// type ButtonProps = {
//   variant?: keyof typeof variants
// } & (
//   | React.ComponentPropsWithoutRef<typeof Link>
//   | (Headless.ButtonProps & { to?: undefined })
// )

// export function Button({
//   variant = 'primary',
//   className,
//   ...props
// }: ButtonProps) {
//   className = clsx(className, variants[variant])

//   if (typeof props.to === 'undefined') {
//     return <Headless.Button {...props} className={className} />
//   }

//   return <Link {...props} className={className} />
// }
